import firebase from "firebase";
import _ from "lodash";
import {getChildList} from "../utils/getChild";


const getObject = async (id, projectID, init = false) => {
  let name;

  const subDoc = await firebase.firestore()
    .collection('projects')
    .doc(projectID)
    .collection('objects')
    .doc(id)
    .get();

  const object = subDoc.data();

  name = object.name;


  if (object.parentId) {
    name += ' > ' + await getObject(object.parentId, projectID);
  }

  if (init) {
    return {
      id: subDoc.id,
      ...object,
      name: name.split(' > ').reverse().join(' > '),
    };
  }

  return name;
}

export const fetchObjectsWithParent = async (id, projectID) => {
  const obj = await getObject(id, projectID, true);
  return {
    id: obj.id,
    name: obj.name,
    objects: obj.objects,
    parentId: obj.parentId || undefined,
    isParent: !!obj.isParent,
  }
}

export const getObjectOptions = async (id) => {
  const result = [];

  const objectsData = await firebase.firestore()
    .collection('projects')
    .doc(id)
    .collection('objects')
    .get();

  await objectsData.forEach((subDoc) => {
    const data = subDoc.data();
    result.push({
      id: subDoc.id,
      name: data.name,
      objects: data.objects,
      index: data.index,
      parentId: data.parentId || undefined,
      isParent: data.isParent,
    });
  });

  const r = _.orderBy(getChildList(result), 'index', ['asc']);

  return [
    {
      label: 'Показать все',
      value: null,
    },
    {
      label: 'Без объекта',
      value: 'all',
    },
    ...r.map((r) => {
      return {
        label: r.name,
        value: r.id,
      };
    })
  ];
}



// WEBPACK FOOTER //
// ./src/firestore/objects.js